module.exports = __webpack_public_path__ + "img/request.fe90ef68.svg";